import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import Button from './Button'

import styles from './DashboardButtonsCard.module.scss'; // Import your CSS file for styling

type DashboardButton = {
    text: string;
    onClick: () => void;
};

type DashboardButtonsCardProps = {
    welcomeMessage?: string | null;
    buttons: DashboardButton[];
};

const DashboardButtonsCard: React.FC<DashboardButtonsCardProps> = ({ welcomeMessage, buttons }) => {
    const chunkButtons = (arr: DashboardButton[], size: number) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
            chunks.push(arr.slice(i, i + size));
        }
        return chunks;
    };

    const buttonRows = chunkButtons(buttons, 5);

    return (
        <Container className="my-4">
            <Row className="data-content align-items-center">
                <Col className={styles["center"]}>
                    <Card className={styles["boas-vindas"]}>
                        <Card.Body>
                            {welcomeMessage && <Card.Title className={styles.h5}>{welcomeMessage}</Card.Title>}
                        </Card.Body>
                        {buttonRows.map((row, rowIndex) => (
                            <Row
                                key={rowIndex}
                                className={[styles["data-content"], "align-items-center", "justify-content-center", "mb-3"].join(' ')}
                            >
                                {row.map((btn, index) => (
                                    <Col key={index} md className={[styles["center"], styles["dashboard-buttons"]].join(' ')}>
                                        <Button label={btn.text} onClick={btn.onClick} variant="primary" type="button" />
                                    </Col>
                                ))}
                            </Row>
                        ))}
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardButtonsCard;
